import { createRoute } from '@tanstack/react-router';

import { nebankaRoute } from '../route';

export const nebankaOcpRoute = createRoute({
	path: '/ocp/$contractId',
	getParentRoute: () => nebankaRoute,
});
